import React from 'react';
import { type TFunction } from 'i18next';

import { LatestProcessCriteriaDTOTalentStatus, TalentDTOStatus } from '@/api/generated';
import RefusedStatusIcon from '@/assets/icons/status-refused.svg?react';
import CircleIcon from '@/components/CircleIcon/CircleIcon';
import { IndicatorChipVariant } from '@/components/statuses/IndicatorChip';

import CompletedStatusIcon from './assets/status-completed.svg?react';
import InTestStatusIcon from './assets/status-in-test.svg?react';
import RegisteredStatusIcon from './assets/status-registered.svg?react';

const TALENT_STATUSES = [
  {
    label: (t: TFunction) => t('filters.options.talentStatus.unassigned'),
    value: LatestProcessCriteriaDTOTalentStatus.GHOST,
    Icon: () => <CircleIcon size={2} sx={{ m: 0 }} />
  },
  {
    label: (t: TFunction) => t('filters.options.talentStatus.registered'),
    value: TalentDTOStatus.REGISTERED,
    Icon: () => <RegisteredStatusIcon />
  },
  {
    label: (t: TFunction) => t('filters.options.talentStatus.inTest'),
    value: TalentDTOStatus.IN_TEST,
    Icon: () => <InTestStatusIcon />
  },
  {
    label: (t: TFunction) => t('filters.options.talentStatus.completed'),
    value: TalentDTOStatus.COMPLETED,
    Icon: () => <CompletedStatusIcon />
  },
  {
    label: (t: TFunction) => t('filters.options.talentStatus.refused'),
    value: TalentDTOStatus.REFUSED,
    Icon: () => <RefusedStatusIcon />
  }
] as IndicatorChipVariant[];

export default TALENT_STATUSES;
